export default "__VITE_ASSET__35BBJGWj__"